import { Box, Hidden, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import VideoJS from '../../../shared/videoPlayer';
import { useStyles } from './styles';
import { languageType } from '../../../../types';
import parseTranslation from '../../../../utils/parse-translation';

export const MentorsInfo = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();
  const oneOnOneDescriptionList = parseTranslation(
    'v2.offeringOverview.drawer_descriptionList_individualSessions',
  );

  const mentorsUrl =
    i18n.language === languageType.ENGLISH
      ? process.env.REACT_APP_INFO_MENTORS_EN
      : process.env.REACT_APP_INFO_MENTORS_DE;

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h3">
        {t('v2.dashboard.section_mentorBanner_label_title')}
      </Typography>
      <Typography className={classes.subtitle} component="p">
        {t('v2.mentorOverview.header_label_subtitle')}
      </Typography>
      <Typography variant="h4" className={classes.callsTitle}>
        {t('v2.offeringOverview.drawer_label_aboutMentorCall')}
      </Typography>

      <ul>
        {oneOnOneDescriptionList?.map((bullet: string) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>

      <Box className={classes.videoContainer}>
        <Hidden xsDown>
          <VideoJS url={mentorsUrl} width={577} height={292} />
        </Hidden>
        <Hidden smUp>
          <VideoJS url={mentorsUrl} />
        </Hidden>
      </Box>
    </Box>
  );
};

export default MentorsInfo;
